module.exports = __webpack_public_path__ + "static/media/16UNODC1.52484155.jpg";